<template>
    <div class="employee-notes">
        <div v-for="note in notes" class="uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right employee-notes-row">
            <pre>{{ note.content }}</pre>
            <div class="by-line">
                -- {{ note.from.full_name }}
                <a href="#" :uk-toggle="'target: #' + deleteModalId" class="uk-float-right uk-padding-remove control"  @click="activateDeleteModal(note.id)"><i class="fas fa-trash"></i></a>
            </div>
        </div>
        <div uk-form-custom class="uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right">
            <textarea class="uk-textarea" v-model="note"></textarea>
            <span class="uk-link" @click="saveNote">
                <i class="fas fa-plus-circle"></i> Add Note
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EmployeeNotes",

        props:{
            uid:Number,
            deleteModalId:String,
            deleteFormRef:String
        },

        data(){
            return {
                notes:[],
                note:""
            };
        },

        mounted(){
            this.loadNotes();
        },

        methods:{
            loadNotes(){
                this.note = "";
                axios.get("/api/employee/"+this.uid+"/notes", {sort:"created_at",dir:"desc"})
                    .then((pack) => this.updateList(pack));
            },
            updateList(pack){
                this.notes = pack.data.data;
            },
            startSearch(){
                this.loadNotes();
            },
            saveNote(){
                axios.post("/api/employee/"+this.uid+"/add-note", {"content": this.note})
                    .then(() => this.loadNotes());
            },
            activateDeleteModal(id){
                this.$root.$refs[this.deleteFormRef].loadForm(id);
            }
        }
    }
</script>

<style scoped>

</style>
